

export const generateRedirectUrl = (operatingSystem, params, scheme, client, packageName, appID) => {

    const appSchemeAndroid = `${scheme}://cloud.castus.tv/vod/${client}/`
    const appSchemeiOS = `https://cloud.castus.tv/vod/${client}/`
    const playStoreLink = `https://play.google.com/store/apps/details?id=${packageName}`
    const appStoreLink = `https://apps.apple.com/app/id${appID}`


    // console.log('operatingSystem', operatingSystem)
    // console.log('params', params)
    // console.log('scheme', scheme)
    
    if (operatingSystem === 'android') return [appSchemeAndroid, playStoreLink]
    else if (operatingSystem === 'ios') return [appSchemeiOS, appStoreLink]
    else console.error('Generate redirect url error: Unsupported operating system')
}